import styled from 'styled-components'
import { breakpoints } from '../../utils/styles/global-styles'

export const Section = styled.div`
  max-width: 90%;
  margin: auto;
`
export const Container = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  @media (max-width: ${breakpoints.m}px) {
    flex-direction: column;
  }
`
export const Card = styled.div`
  background: #d8f3f4;
  padding: 32px 16px;
  display: flex;
  border-radius: 16px;
  flex-direction: column;
  width: 247px;
  text-align: center;
  #returns {
    width: 44px;
  }
  #support {
    width: 37px;
  }
  #secure {
    width: 41px;
  }
  #usaBased {
    width: 35px;
  }
  @media (max-width: ${breakpoints.m}px) {
    margin: auto;
  }
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
  }
`

export const Title = styled.p`
  margin: 0px;
  font-family: 'MatterBold';
  font-size: 14px;
  line-height: 21px;
`
export const Text = styled.p`
  margin: 0px;
  font-size: 14px;
  line-height: 21px;
`
export const ImageContainer = styled.div`
  margin: 0px auto 16px;
`
